import {
  takeLeading, put, select, call,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import homeActions from './home.actions';
import { HomeActionTypes } from './home.types';
import { config } from '@/config';
import { isBRServer } from '@/utils/Validators/validation';
import logger from '@/utils/logger';

const { WHMCS_URL } = config;

export const getHomeContent = function* getHomeContent() {
  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: `${WHMCS_URL}/api/v3/pages/home`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
      brand,
    },
  };

  yield put(homeActions.loading(true));

  try {
    const response = yield call(api.whmcs.get, request);
    yield put(homeActions.getHomeContent.success());

    yield put(homeActions.getHomeContent.set(response.data && response.data.modules));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas homeContent - method getHomeContent', error);
    yield put(homeActions.getHomeContent.failure());
  }

  yield put(homeActions.loading(false));
};

export const menuIsOpen = function* menuIsOpen(action) {
  yield put(homeActions.menuIsOpen(action.payload));
};

function* sagas() {
  yield takeLeading(HomeActionTypes.HOME_GET_REQUEST, getHomeContent);
  yield takeLeading(HomeActionTypes.MENU_IS_OPEN, menuIsOpen);
}

export default sagas;
